import { InAppBrowser, InAppBrowserObject } from '@awesome-cordova-plugins/in-app-browser'
import { Capacitor } from '@capacitor/core'
import { useRef, useState } from 'react'
import { useHistory } from 'react-router'
import { trpc } from '../../../modules/trpc'
import { getAuthParamsFromUrl, isAuthenticationRedirectUrl } from '../../../utils/authHelpers'
import useBankAuth from './authenticateWithTeliaToken'

const useBankAuthFlow = () => {
	const bankAuthMutation = useBankAuth()
	const history = useHistory()

	const [isLoading, setLoading] = useState(false)

	const browser = useRef<InAppBrowserObject>()

	const { data: teliaUrl } = trpc.auth.getTeliaLoginUrl.useQuery()

	const startAuth = async () => {
		setLoading(true)

		if (!teliaUrl) {
			throw new Error('Failed to get Telia login URL')
		}

		if (Capacitor.isNativePlatform()) {
			const iab = InAppBrowser.create(teliaUrl, '_blank', 'location=no')
			browser.current = iab

			iab.on('loadstart').subscribe(async (value: any) => {
				if (isAuthenticationRedirectUrl(value.url)) {
					const { code, error } = getAuthParamsFromUrl(value.url)

					iab.close() // Close the browser immediately so it doesn't get stuck open on an error return

					if (error) {
						setLoading(false)
						history.push('/')
						return
					}

					if (code) {
						try {
							await bankAuthMutation.mutateAsync({ code })
						} catch (err) {
							setLoading(false)

							console.error('Failed to complete bank auth:', err)
							history.push('/')
							return
						}
						history.push('/overview')
					}
					iab.close() // ensure browser is closed
				}
			})
		} else {
			console.log('Redirecting to Telia login URL in web environment:', teliaUrl)
			window.location.href = teliaUrl
		}
	}

	return { startAuth, isLoading }
}

export default useBankAuthFlow
